module.exports = __webpack_public_path__ + "img/four-enabled.9d9b05f4.svg";